export const CHANGE_HOME_NEWS_LIST = 'home/CHANGE_HOME_NEWS_LIST'
